import React from 'react';
import { BrowserRouter, Route } from 'react-router-dom';

import JobListing from './pages/JobListing';

export default () => (
        <Route path="/" component={JobListing} />
);
